module.exports = __webpack_public_path__ + "img/wechartCode.fc3afffb.png";